import { useCallback, useMemo } from 'react';
import { useDrawerContext } from '../context';

type UseDrawerToggleResult = {
  isDrawerOpened: boolean;
  toggleDrawer: () => void;
};

const useDrawerToggle = (): UseDrawerToggleResult => {
  const { isDrawerOpened, setDrawerOpened } = useDrawerContext();

  const toggleDrawer = useCallback((): void => {
    setDrawerOpened((prevDrawerOpened) => !prevDrawerOpened);
  }, []);

  return useMemo(
    () => ({
      isDrawerOpened,
      toggleDrawer,
    }),
    [isDrawerOpened, toggleDrawer]
  );
};

export default useDrawerToggle;
